module.exports = __webpack_public_path__ + "assets/img/18.573fa7fb.png";